import { useSearchParams } from 'react-router';

type ResT = {
  email: string;
  firstName: string;
  lastName: string;
  token: string;
  userId: string;
};

export function usePasswordResetPageQuery(): ResT {
  const [q] = useSearchParams();

  return {
    email: q.get('email') ?? '',
    firstName: q.get('firstName') ?? '',
    lastName: q.get('lastName') ?? '',
    token: q.get('token') ?? '',
    userId: q.get('userId') ?? '',
  };
}
